import { useAppSelector } from ".";
import { selectSessionState } from "../features/sessionSlice";
import { useApplicationForApplicationBuildQuery } from "./useApplicationBuildsQuery";

export function useApplicationForSessionQuery() {
  const session = useAppSelector(selectSessionState);

  return useApplicationForApplicationBuildQuery(session.applicationBuildId);
}
